var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"optionsContainer"},[_c('a',{staticClass:"optionsLink",on:{"click":_vm.letsBuild}},[_vm._v("Let's build!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }